import { DragOverlay } from '@dnd-kit/core';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ISelectionFormValues } from 'widgets/selections/utils/types';

interface ISelectionOptionDragOverlay {
  activeIndex: number;
}

export const SelectionOptionDragOverlay = ({ activeIndex }: ISelectionOptionDragOverlay) => {
  const form = useFormContext<Pick<ISelectionFormValues, 'options'>>();
  const title = activeIndex ? form.watch(`options.${activeIndex}.title`) : null;

  return (
    <DragOverlay>
      {activeIndex ? (
        <Box
          sx={{
            p: 1.5,
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            background: 'white',
            borderRadius: 1,
            width: (title?.length ?? 5) * 10 + 60,
            boxSizing: 'border-box',
          }}
        >
          {title}
        </Box>
      ) : null}
    </DragOverlay>
  );
};
